/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateDefaultInstrument} from '../api'

export const useMutationUpdateDefaultInstrument = createReactQueryMutationHook('updateDefaultInstrument', updateDefaultInstrument)
